export default {
	0: 'GI',
	1: 'RS',
	2: 'Autre poste dans le logement social',
}